import React from "react";
import styled, { css } from "styled-components";
import { ReactComponent as CheckSVG } from "../assets/svg/check2.svg";

const CheckboxButton = ({
  text = "",
  checked = false,
  hasError = false,
  innerRef,
  className,
  ...rest
}) => {
  return (
    <Container
      className={className}
      checked={checked}
      hasError={hasError}
      ref={innerRef}
    >
      <InputStyled type="checkbox" checked={checked} {...rest} />
      <Icon as={CheckSVG} />
      {text}
    </Container>
  );
};

const Container = styled.label`
  border-radius: 15px;
  cursor: pointer;

  display: flex;
  align-items: center;

  padding: 15px;

  position: relative;

  user-select: none;

  transition: all 100ms;

  background-color: white;

  ${({ checked, hasError }) => {
    if (hasError) {
      if (checked) {
        return css`
          border: 1px solid #f44336;
          background-color: #eaf9f4;
        `;
      } else {
        return css`
          border: 1px solid #f44336;
        `;
      }
    } else {
      if (checked) {
        return css`
          border: 1px solid #33c494;
          background-color: #eaf9f4;
        `;
      } else {
        return css`
          border: 1px solid #ccc;
          background-color: white;
        `;
      }
    }
  }}

  &:hover {
    /* box-shadow: 0 2px 8px 0px #cccccc; */
    /* ${({ checked, hasError }) => {
      if (!checked && !hasError)
        return css`
          border: 1px solid #33c494;
        `;
    }} */
  }
`;

const Icon = styled.div`
  position: absolute;
  width: 14px;
  height: 14px;

  margin: 0px 3px;

  fill: #33c494;

  display: none;
`;

const InputStyled = styled.input`
  appearance: none;
  width: 20px;
  height: 20px;

  min-width: 20px;
  min-height: 20px;

  border: 1px solid #cccccc;
  border-radius: 5px;

  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: 15px;

  cursor: pointer;

  &:checked {
    background-color: white;
    border: 1px solid #33c494;

    & ~ ${Icon} {
      display: block;
    }
  }
`;

export default React.forwardRef((props, ref) => (
  <CheckboxButton innerRef={ref} {...props} />
));
